import React from 'react'
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";

const CancelTicket = () => {
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">Ticket to Cancel</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row mt-4">
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="From Date "
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="To Date "
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiSearchSelect
                        placeholder={"Business Unit"}
                        label="Business Unit"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={"Branch"}
                        label="Branch"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiInput
                        label="Customer Name"
                        placeholder="Enter Customer Name"
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiInput
                        label="Payment Mode"
                        placeholder="Enter Payment Mode"
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={" Product Type"}
                        label="Product Type"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={" Airline Category"}
                        label="Airline Category"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={" Airport Type"}
                        label="Airport Type"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={" Cancellation Mode"}
                        label="Cancellation Mode"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={" Airline Name"}
                        label="Airline Name"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        placeholder={" Status"}
                        label=" Status"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton className="clear-btn " label="Clear" />
                        <MuiButton
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                          label={"Get Track"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  )
}

export default CancelTicket
